import { useDispatch, useSelector } from "react-redux";
import {
  addDetailedCmt,
  removeDetailedCmt,
  updateAll,
  updateApvDate,
  updateApvExpDate,
  updateApvNo,
  updateDetailedCmt,
  updateNotiDate,
  updateRcptDate,
  updateStatus,
  updateStep,
  updateSubmDate,
  updateTaskCodeId,
  updateTaskCodeListId,
} from "./Redux/IRB";
import { DataGrid, Form, Toolbar } from "devextreme-react";
import {
  EmptyItem,
  Label,
  RequiredRule,
  SimpleItem,
} from "devextreme-react/form";
import { useEffect, useState } from "react";
import axios from "axios";
import { status } from "./data";
import styled from "styled-components";
import {
  Button,
  Column,
  Editing,
  HeaderFilter,
  Paging,
  Scrolling,
  SearchPanel,
  Selection,
  Sorting,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { getDateString } from "../../../common/date";
import { Item } from "devextreme-react/toolbar";
import { useRef } from "react";

import "./index.css";

export default function IRBRelatedActivitiesForm(props) {
  const {
    //  step, setStep,
    taskDataSource,
  } = props;

  const dispatch = useDispatch();

  const IRB = useSelector((state) => state.IRB);
  const userInfo = useSelector((state) => state.userInfo);

  const formIRBRelatedActivitiesRef = useRef(null);
  const detailedCommentGridRef = useRef(null);

  // const [taskDataSource, setTaskDataSource] = useState(null);
  const [detailedCmtDataSource, setDetailedCmtDataSource] = useState(null);
  // useEffect(async () => {
  //   const result = await axios.get(
  //     `${process.env.REACT_APP_BECCO_API_URL}/api/common/codeList?name=IRB Submission&cat=13`
  //   );

  //   setTaskDataSource(result.data.code);

  //   dispatch(
  //     updateTaskCodeListId({
  //       taskCodeListId: result.data.codeListId,
  //     })
  //   );
  // }, []);

  useEffect(() => {
    setDetailedCmtDataSource(
      new CustomStore({
        key: "SEQ",
        load: () => {
          return IRB.detailedCmt;
        },
        insert: (values) => {
          if (values.comment) {
            dispatch(
              addDetailedCmt({
                detailedCmt: values,
              })
            );
          }
        },
        update: (key, values) => {
          if (values.comment) {
            dispatch(
              updateDetailedCmt({
                detailedCmt: {
                  ...values,
                  SEQ: key,
                },
              })
            );
          }
        },
        remove: (key) => {
          dispatch(
            removeDetailedCmt({
              detailedCmt: {
                SEQ: key,
              },
            })
          );
        },
      })
    );
  }, [IRB.detailedCmt]);

  const onTaskCodeIdValueChanged = (e) => {
    dispatch(
      updateTaskCodeId({
        taskCodeId: e.value,
      })
    );
  };

  const onStatusValueChanged = (e) => {
    dispatch(
      updateStatus({
        status: e.value,
      })
    );
  };

  const onSubmDateValueChanged = (e) => {
    dispatch(
      updateSubmDate({
        submDate: e.value,
      })
    );
  };

  const onRcptDateValueChanged = (e) => {
    dispatch(
      updateRcptDate({
        rcptDate: e.value,
      })
    );
  };

  const onApvDateValueChanged = (e) => {
    dispatch(
      updateApvDate({
        apvDate: e.value,
      })
    );
  };

  const onNotiDateValueChanged = (e) => {
    dispatch(
      updateNotiDate({
        notiDate: e.value,
      })
    );
  };

  const onApvNoValueChanged = (e) => {
    dispatch(
      updateApvNo({
        apvNo: e.value,
      })
    );
  };

  const onApvExpDateValueChanged = (e) => {
    dispatch(
      updateApvExpDate({
        apvExpDate: e.value,
      })
    );
  };

  const calculateCellValue = (data) => {
    if (data) {
      return `${data.name} (${data.commentator})`;
    } else {
      return null;
    }
  };

  const disabled = (e) => {
    if (e.row.data.commentator == userInfo.employeeNo) {
      return false;
    } else {
      return true;
    }
  };

  const allowEditing = (e) => {
    if (e.row.data.commentator == userInfo.employeeNo) {
      return true;
    } else {
      return false;
    }
  };

  const onInitNewRow = (e) => {
    e.data.commentator = userInfo.employeeNo;
    e.data.name = userInfo.name;
    e.data.date = getDateString(new Date());
  };

  const onEditingStart = (e) => {
    dispatch(
      updateAll({
        ...e.data,
      })
    );
  };

  const onNextClick = (e) => {
    // setStep(1);
    dispatch(
      updateStep({
        step: 1,
      })
    );
  };

  const nextItemOptions = {
    text: "NEXT",
    onClick: () => {
      if (formIRBRelatedActivitiesRef.current.instance.validate().isValid) {
        // setStep(1);
        dispatch(
          updateStep({
            step: 1,
          })
        );

        if (detailedCommentGridRef.current) {
          detailedCommentGridRef.current.instance.saveEditData();
        }
      }
    },
  };

  return (
    <div
      style={{
        margin: "3px auto",
        width: "75vw",
      }}
    >
      <span style={{ fontWeight: 500, color: "#009688", marginLeft: "10px" }}>
        IRB Related Activities
      </span>
      <Form
        id="form-IRBRelatedActivities"
        ref={formIRBRelatedActivitiesRef}
        colCount={4}
        labelMode="outside"
        labelLocation="top"
        showColonAfterLabel={true}
        style={{
          padding: "16px",
        }}
        validationGroup="IRBRelatedActivitiesData"
      >
        <SimpleItem
          dataField={"taskCodeId"}
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: taskDataSource,
            valueExpr: "codeId",
            displayExpr: "name",
            value: IRB.taskCodeId,
            showClearButton: true,
            onValueChanged: onTaskCodeIdValueChanged,
          }}
        >
          <Label text={"심의종류 (Task)"} />
          <RequiredRule message={"심의종류 (Task)는 필수입니다."} />
        </SimpleItem>
        <SimpleItem
          dataField={"status"}
          editorType={"dxSelectBox"}
          editorOptions={{
            value: IRB.status,
            dataSource: status,
            valueExpr: "id",
            displayExpr: "name",
            showClearButton: true,
            onValueChanged: onStatusValueChanged,
          }}
        >
          <Label text={"Status"} />
          <RequiredRule message={"Status는 필수입니다."} />
        </SimpleItem>
        <SimpleItem
          dataField={"submDate"}
          editorType={"dxDateBox"}
          editorOptions={{
            value: IRB.submDate,
            showClearButton: true,
            displayFormat: "yyyy-MM-dd",
            dateSerializationFormat: "yyyy-MM-dd",
            useMaskBehavior: true,
            onValueChanged: onSubmDateValueChanged,
          }}
        >
          <Label text={"Submission Date (PI 제출일)"} />
        </SimpleItem>
        <SimpleItem
          dataField={"rcptDate"}
          editorType={"dxDateBox"}
          editorOptions={{
            value: IRB.rcptDate,
            showClearButton: true,
            displayFormat: "yyyy-MM-dd",
            dateSerializationFormat: "yyyy-MM-dd",
            useMaskBehavior: true,
            onValueChanged: onRcptDateValueChanged,
          }}
        >
          <Label text={"Receipt Date (IRB 접수일)"} />
        </SimpleItem>
        <SimpleItem
          dataField={"apvDate"}
          editorType={"dxDateBox"}
          editorOptions={{
            value: IRB.apvDate,
            showClearButton: true,
            displayFormat: "yyyy-MM-dd",
            dateSerializationFormat: "yyyy-MM-dd",
            useMaskBehavior: true,
            onValueChanged: onApvDateValueChanged,
          }}
        >
          <Label text={"Approval Date (승인일)"} />
        </SimpleItem>
        <SimpleItem
          dataField={"notiDate"}
          editorType={"dxDateBox"}
          editorOptions={{
            value: IRB.notiDate,
            showClearButton: true,
            displayFormat: "yyyy-MM-dd",
            dateSerializationFormat: "yyyy-MM-dd",
            useMaskBehavior: true,
            onValueChanged: onNotiDateValueChanged,
          }}
        >
          <Label text={"Approval Date (통지일)"} />
        </SimpleItem>
        <SimpleItem
          dataField={"apvNo"}
          editorType={"dxTextBox"}
          editorOptions={{
            value: IRB.apvNo,
            showClearButton: true,
            onValueChanged: onApvNoValueChanged,
          }}
        >
          <Label text={"IRB 승인번호"} />
        </SimpleItem>
        <SimpleItem
          dataField={"apvExpDate"}
          editorType={"dxDateBox"}
          editorOptions={{
            value: IRB.apvExpDate,
            showClearButton: true,
            displayFormat: "yyyy-MM-dd",
            dateSerializationFormat: "yyyy-MM-dd",
            useMaskBehavior: true,
            onValueChanged: onApvExpDateValueChanged,
          }}
        >
          <Label text={"승인 유효기간"} />
        </SimpleItem>
        <SimpleItem
          dataField={"detailedCmt"}
          editorType={"dxDataGrid"}
          colSpan={4}
          render={() => (
            <DataGrid
              id="detailedCommentGrid"
              ref={detailedCommentGridRef}
              dataSource={detailedCmtDataSource}
              allowColumnReordering={true}
              allowColumnResizing={true}
              columnResizingMode="widget"
              rowAlternationEnabled={true}
              showBorders={true}
              showRowLines={true}
              showColumnLines={true}
              width={"100%"}
              height={"100%"}
              repaintChangesOnly={true}
              highlightChanges={true}
              columnAutoWidth={true}
              wordWrapEnabled={true}
              style={{ maxHeight: "800px", marginBottom: "10px" }}
              onInitNewRow={onInitNewRow}
              // onEditingStart={onEditingStart}
            >
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
              />
              <Scrolling
                mode={"virtual"}
                rowRenderingMode={"virtual"}
                columnRenderingMode={"virtual"}
                showScrollbar={"always"}
              />
              <HeaderFilter visible={true} />
              <Paging enabled={false} />
              <Sorting mode={"multiple"} />
              <Selection mode={"none"} />

              <Editing
                // mode={"batch"}
                // mode={"row"}
                mode={"cell"}
                allowAdding={true}
                allowUpdating={true}
                allowDeleting={true}
                selectTextOnEditStart={true}
                startEditAction={"dblClick"}
              />

              <Column
                dataField={"commentator"}
                caption={"Commentator"}
                width={135}
                calculateCellValue={calculateCellValue}
                allowEditing={false}
              />
              <Column
                dataField={"date"}
                caption={"Date"}
                width={95}
                format={"yyyy-MM-dd"}
                dataType={"date"}
                allowEditing={false}
              />
              <Column
                dataField={"comment"}
                caption={"Comment"}
                showEditorAlways={true}
                allowEditing={allowEditing}
              />
              {/* <Column type={"buttons"}>
                <Button name={"delete"} disabled={disabled} />
              </Column> */}
            </DataGrid>
          )}
        >
          <Label text={"Detailed Comment"} />
          {/* <DataGrid
            id="detailedCommentGrid"
            ref={detailedCommentGridRef}
            dataSource={detailedCmtDataSource}
            allowColumnReordering={true}
            allowColumnResizing={true}
            columnResizingMode="widget"
            rowAlternationEnabled={true}
            showBorders={true}
            showRowLines={true}
            showColumnLines={true}
            width={"100%"}
            height={"100%"}
            repaintChangesOnly={true}
            highlightChanges={true}
            columnAutoWidth={true}
            wordWrapEnabled={true}
            style={{ maxHeight: "800px", marginBottom: "10px" }}
            onInitNewRow={onInitNewRow}
            // onEditingStart={onEditingStart}
          >
            <SearchPanel
              visible={true}
              highlightCaseSensitive={true}
              width={240}
            />
            <Scrolling
              mode={"virtual"}
              rowRenderingMode={"virtual"}
              columnRenderingMode={"virtual"}
              showScrollbar={"always"}
            />
            <HeaderFilter visible={true} />
            <Paging enabled={false} />
            <Sorting mode={"multiple"} />
            <Selection mode={"none"} />

            <Editing
              mode={"batch"}
              allowAdding={true}
              allowUpdating={true}
              allowDeleting={true}
              selectTextOnEditStart={true}
              startEditAction={"dblClick"}
            />

            <Column
              dataField={"commentator"}
              caption={"Commentator"}
              width={135}
              calculateCellValue={calculateCellValue}
              allowEditing={false}
            />
            <Column
              dataField={"date"}
              caption={"Date"}
              width={95}
              format={"yyyy-MM-dd"}
              dataType={"date"}
              allowEditing={false}
            />
            <Column
              dataField={"comment"}
              caption={"Comment"}
              showEditorAlways={true}
            />
            <Column type={"buttons"}>
              <Button name={"delete"} disabled={disabled} />
            </Column>
          </DataGrid> */}
        </SimpleItem>
      </Form>
      <Toolbar>
        <Item
          location={"after"}
          widget={"dxButton"}
          options={nextItemOptions}
        />
      </Toolbar>
    </div>
  );
}
